import Config from "../config";

export type DynatraceLog = {
    Level: string;
    Timestamp: string;
    [key: string]: any;
};

export type TransformedLog = {
    content: Record<string, any>;
    severity: string;
    timestamp: string;
    application: string;
    channel?: string;
    environment?: string;
    sessionId?: string;
};

export const dynatraceRequestAdapter = async (logs: DynatraceLog[]): Promise<void> => {
    try {
        const transformedLogs: TransformedLog[] = logs.map((log) => {
            const { Level, Timestamp, Session, Application, Channel, Environment, ...content } = log;

            return {
                content,
                severity: Level,
                timestamp: Timestamp,
                application: Application,
                channel: Channel,
                environment: Environment,
                sessionId: Session,
            };
        });

        await fetch(Config.dynatraceLogger.url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: `API-Token ${Config.dynatraceLogger.token}`,
            },
            keepalive: true,
            body: JSON.stringify(transformedLogs),
        });
    } catch (error) {
        console.error("Failed to send log to Dynatrace", error);
    }
};
